'use client'

// Third-party Imports
import { SessionProvider } from 'next-auth/react'
import type { SessionProviderProps } from 'next-auth/react'

// Configs Imports
import { SESSION_REFETCH_INTERVAL_S } from '@configs/authSession'

export const NextAuthProvider = ({ children, ...rest }: SessionProviderProps) => {
  return (
    <SessionProvider
      basePath={process.env.NEXTAUTH_BASEPATH}
      refetchOnWindowFocus
      refetchInterval={SESSION_REFETCH_INTERVAL_S}
      refetchWhenOffline={false}
      {...rest}
    >
      {children}
    </SessionProvider>
  )
}
